import Qs from 'querystring'

const urlParams = Qs.parse(window.location.search.substr(1))

const renderBgimage = (d, isSuWebp) => {
    if (d.imageType && d.imageType !== 'image') {
        return d.image
    }
    if ([undefined, 'image'].includes(d.imageType) && d.image) {
        if (isSuWebp && d.image.indexOf('pics/') > -1) {
            const url = 'https://web-static.didachuxing.com/pics/' + d.image.split('pics/').pop()
            return `url('${url.replace(/\.(jpg|png|gif)/, '.webp')}')`
        }
        return `url(${d.image})`
    }
    return 'none'
}

export const renderBg = (d = {}, isSuWebp) => ({
    'backgroundColor': d.color,
    'backgroundImage': renderBgimage(d, isSuWebp),
    'backgroundRepeat': d.repeat,
    'backgroundSize': d.size || 'cover',
    'backgroundPosition': d.position || 'top center',
    'backgroundOrigin': d.origin
})

export const drawCanvasWM = ({
    container = document.body,
    width = '300px',
    height = '200px',
    font = '20px Microsoft Yahei',
    content = '灵动设计',
    rotate = -35,
    opacity = 0.3
} = {}) => {
    // const svgStr = `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}">
    //   <text x="20%" y="20%" dy="12px"
    //     text-anchor="middle"
    //     stroke="#000000"
    //     stroke-width="1"
    //     stroke-opacity="${opacity}"
    //     fill="none"
    //     transform="rotate(-${rotate}, 0, 0)"
    //     style="font-size: ${font};">
    //     ${content}
    //   </text>
    // </svg>`

    // const base64Url = `data:image/svg+xml;base64,${window.btoa(unescape(encodeURIComponent(svgStr)))}`
    const base64Url = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANsAAABoCAYAAAEP2rUNAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAA26ADAAQAAAABAAAAaAAAAACvt2D6AAAK5ElEQVR4Ae2de7BVVR3HRROU1DQR8IFgmJhYOfjAVzwkpUwl0hRFZdLGMSun1JqcHg5/NE1NWFqDUxPpH/ZPNdPk2IyZjmIZplMqmmaDGaJAQr5SCRXp87msJXu2514ujAPB+f5mPqy1115n77s/ez3OPXefxXbbbaH4fOO8V5X8pJJOJK1lU0rZJifbl1f+gPTA1lEGsO2JhjXKH2jkk42BGIiBGFhv4MiSnbG+6M1ccxw9483STcg4aDswn1xeO6qklk0v+eNLegLp2JJPEgMxEAMx8PYZ2KEcyrF3UmEV6dNgWD6/J7f+n4vJnggHwf1wLjwLlt8NNUaQ+SLsBY/Uwi2VXsaJz2+c3InlHPACT22Ud8q+oxRatxlfaW4kHwMxEAMxEAMxEAMxEANbu4HLuYBx0HzjuyfbE2Ao1PhayZxVC0h9jR8nfaBV5mbzeI3dmydb383PKadb3jjt8+THw12NsnvJD4aDS9nIku5P+quS35H071BFlOLNn3hx/k73JXgKRsNsML4KC+FTcD3sAl7Ua/AGGIvBC/Yia5n7/V3P4wyALR7+eckPCP0drsYlZAZCu2l9plYo6U6kF4EX8pFS5t1LxEAMxEAMxEAMxEAMxEAMxEAMxEAMxEAMxEAMbG4Dwzlh/by207n9xM/PXK+EL3eqQJmf7vXnY0s/Ht27HMOPO78Onc59OOWDSr3dSK8o+a5Mtm9c9aXkR4FSpoI3Zwz4gXo7ZlKwAKzT20P5fu58GPiR7rvAc10E7biGgmXg/pPAm+3NrM82ke2J/fh3COwBL8I7wb9Y+NeMrosqR7HHwtpi4E+k/tlnGPjQ1r+hGd6spaDw/8JyaIa9cTJ4491vD/okXAveyDXwJIwEP7N/Afyry5SSv5n0GajhA2TW9c9Q3lhv8vthLiyGro5vcPW7g38QORu8qceBN68d7vcGWMdW31ucy46DYDoo3NfYSJrhDbbcug67x5TtI0jbYb1BpdB8omVgcGu7vansZjhsOdT2Fv5Zb1PiqD5edGYf+7IrBmIgBmIgBmIgBmIgBmIgBmIgBmIgBmIgBmIgBmIgBmIgBmIgBmIgBmIgBmIgBmIgBmIgBmIgBmIgBvpjoD693Kzrc48+G+lTx53Ch1l9lnIWTALXa3kJ2uHDrqvbha3tU9j2KeRHS/nnSA+F+8t2TTznIbCiFFxZ8u2nqsvubTvx0e0ao8j4NLAPne4DF4JPLrdjLQXe1BvKjgtK2k58wtjjKdwYD/Wp454C/vHRcm/SFWDdn4FrlLbDc7pykXWMb8EM8Knorot60+xxs2A2DIS9YR58GDqFX9yo6+t8s1MFyvwSxgLwyxqGj5G/2pNb/4/ftvGc3wV7dr3B7SeSd2Xf7QWSnsfiTfcFvwHUVVGHx5lc9Z1wIiyCE+BZcEiaD+3YnwK5DZa0d5btnUk/DnNhKoyCieCXNlZC7XV+ccMh9nXwyxvenDuhGd7s0WDqMaeAMRK8oY+50S1Re5pCHoYD4SGw9b4CncLecGPZsZTUb9s0w5vhMHYZ2Gud75yL1oBzUO1Fqxt5e/ZwcB48A5rhz+jxToNp8CNYBr5+NvwauirqTVvLVQ8FW7s3xbD3dQrXZjun7HCYrMNfratMh0bjGrgQxsIOsCfcCzXmkHkOjgZvtj+HPa0Zb7Dx/UaBdV4GG0RXhiINhye/CmUvOxuuBb/Pdis41zTjETYcRu011rkPHPKacQ8b3oxZcDXYM+xFq+Dn0AznRo9jnTHgDfkE/B5q2BA+CDvBfPDnHgZ+R6+rw15wFUyDiWCPqr2O7JtxOjnrGQ5Z5qW3NwS9lfOSnqgN53y2hpSyGaT1HKWoJ6kjw27NwuTXGfBNRG8xjh27tHZOYbs9F9Uq762ZjUz32cj6qR4DMRADMRADMRADMRADMRADMRADMRADMRADMRADMRADMRADMRADMRADMRADMRADMRADMRADMRADMRADMRADMRADMRADMRADMRADMRADMRADMRADMRADMRADMRADMRADMRADMRADMRADMRADMRADMbBFDNR14DbnyV1I0MV2XQnSNeVcIfJV+H8MV5Z0jT4XNXw7YjQHcRFFV9dMdJmBTgs7VgWujDkZDob2QotLKLsLFkF/wgWHLwQ7mvEazINPg+vq2pivKylJn2EHuBRegN/Ck7Cp4UKSLmR5SDnATaT3w15wKvwCLobBUPeR7TN8rdflgpd/hlvANYGNA+Es8Jr1dwckusRAp5ntAK7dxjwebCwu8jy/xUK2TwFX8X4MXGi6r3Dmchnbp8BOvDt4fBu76xX/FJ6H/oQN94/goqHTYRKshcVQYwoZV239Bzhz9hZ2XOv6czkAOOM4gFwCLtVr2WFg+W2wCjYU+1HB1wwAFx11ZnQ5YcNrPA70vi9Y3p9jUi2xtRtodzbf2rkO9YPwE3gFvgA2SGeSWfA+cP/jcAzYgJbAhmIQFZwhJkFd5tjGPAc89saGnWsBuE72e+BRsCM6E58Mf4G/gufoLeykHsM6DiDOanaCo8HjOvOMAWf2I8BZ62/QKexcI+AJmN+gdjSvfSrYGQ0HmqNgEuwND0NiGzbg25kaNpZpZeMPpHY8l5e2IznzDAL32xhdXtpto6+ZY12N9f/6eo/na2+AjfldbQ/q2+gnwEjYAWpcT8aG6/E+Cs4WD8FMcHYxfgl2PsMZ7TKo12CZHd7j6ORacNCZBbuDnfgmWAidwln2JHAAmgwHQI2XydhxneFqrCXjz3IXrAA7XmIbN9BssDYGZyob6u3g7yw27h+DI7+j7zgwnoDTenLrGvXKku8tOY8dr4MN1nQ8eG7zzpzOJOafht7CRvwxsNPVxvkieQeCZ+EQOAiWwzBYCvXnJdszSzlTG3YeB5QF4HV7ndfB6eDsNhKegwfAGc2f7TclJXlL2MmfgenguZthJ78F5sNwGAIDwJ/bn9+w8yW2cQPNzraKax0BQ8G8DcBZwZH+eLCx26gdqQ8DYzX8Dt6AvhqMnelIsPEfAP7e5tuqY8HwHI+BHaS3WMSOe8Cfzc7vrOC2g4IDgeX/hGVwMDj7Gv+CH8J/3GiFnc56+8Ex8BI8Dk/AznAeGM+Dnc/Ua+0Unt/OezdMaFS4nbyejJGwb09u3f9o1ZezUi3JtmLAEbYddoYzwQZyKzwKnRrFaMrfDfdBf8K3Wp8FO9rN4O9+teE9Rd5O4gcyvp3bUOxKBd8u2inq+T329VBnL+uYt0P1Fc4254PXOA8OBQcW43G4EbxWB5xRYDwIXsPrbnQIj+EgoMPvQfU3gvwFMBdWQKKLDHTqbPXy7RSHgw3HTjUQDH/XuBNWQn9iLJXOKBV922SDNh0CdrY14Nu4D4HnNOx0Nub+xjAq+jbyjv6+YAP1vN5Os9iOlE8Dr8m3jt+G3mY6dr0lfCdxOXznLXtSEANbiQHfkm4t4VvzRAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQAzEQBcZ+B9FrbXTM/S3qAAAAABJRU5ErkJggg=='
    const styleStr = `
      pointer-events:none;
      background-repeat:repeat;
      opacity: ${opacity};
      transform: rotate(${rotate}deg);
      background-image:url('${base64Url}')`

    container.setAttribute('style', styleStr)
}

export const addScript = (url) => {
    const wb = document.createElement('script')
    const s = document.getElementsByTagName('script')[0]
    wb.type = 'text/javascript'
    wb.async = false
    wb.src = url
    return new Promise((resolve) => {
        // eslint-disable-next-line no-multi-assign
        wb.onload = wb.onreadystatechange = function() {
            if (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete') {
                resolve()
            }
        }
        s.parentNode.insertBefore(wb, s)
    })
}

/**  根据Href参数获取值 */
const getValueByHref = (params) => urlParams[params] || ''

/**
 * 根据参数 获取window值
 */
const getValueByWindow = (params) => {
    const prevObj = params.reduce((prev, next) => {
        let getVal
        if (window[next]) {
            getVal = window[next] || ''
        } else {
            getVal = (prev && prev[next]) || ''
        }
        return getVal
    }, null)
    return prevObj
}

/**
 * 从cookie里面获取
 */
const cookieGet = (key) => document.cookie.split('; ')
    // eslint-disable-next-line prefer-template
    .find((cookie) => cookie.startsWith(key + '='))
    ?.split('=')[1] || ''

/** 获取模版字符串对应的对象值 */
export const getTypeValue = (link = '') => {
    const getNoStrParams = link.match(/\$\{[^{}]+(?=\})/g)
    const params = getNoStrParams?.reduce((prev, next) => {
        const getName = next.replace('${', '').split('.')
        const getType = String(getName[0]).toLocaleLowerCase()
        let getValue
        switch (getType) {
        case '_url': {
            getValue = getValueByHref(getName.slice(1, 2))
            break
        }
        case '_cookie': {
            getValue = cookieGet(getName.slice(1, 2))
            break
        }
        case '_window': {
            getValue = getValueByWindow(getName.slice(1, getName.length))
            break
        }
        default:
            getValue = ''
        }
        prev.push(getValue)
        return prev
    }, [])

    return params || link
}

export const getLogParams = (logParams = {}) => {
    const arr = []
    for (let index = 1; index < 11; index++) {
        const val = getTypeValue(logParams[`P${index}`])
        arr.push(Array.isArray(val) ? val.join('') : val)
    }
    return arr
}
